import React, { useState, useEffect, useCallback } from "react";
import { useForm, FormProvider } from "react-hook-form";
//Material
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from "@material-ui/core/LinearProgress";
//Component
import FormInput from "../../stories/hook-controls/input";
import FormAutocomplete from "../../stories/hook-controls/input-autocomplete";
import { Modal } from "../../stories/modal";
import { BoxTemplate1 } from "../../stories/Box";
import { ReactTable } from "../../stories/react-table";
//Function
import { getPermissionColumns } from "./columns/Column";
import * as common from "../../utils/common-function";
import * as alertDialog from "../../utils/alert";
import * as api from "./api";
import { GetListUserMaintenance } from "./../user-maintenace/api";
import { useSelectItem } from "../../stories/react-table/useSelectItem";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 1200,
  },
  labelTitle: {
    marginTop: theme.spacing(0),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    minWidth: 150,
  },
  inputHeader: { maxWidth: 600 },
  inputBrowse: { maxWidth: 530 },
  textLabel: {
    color: "#000",
    whiteSpace: "nowrap",
  },
  validateTypeCell: {
    maxWidth: 80,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  conditionTextInput: {
    minWidth: 350,
  },
  rootSearch: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    width: 300,
  },
}));

function AddEditTemplateAuthorizeModal(props) {
  const classes = useStyles();

  const { open, onClose, editmode } = props;
  const { data, fetchmain = () => {}, ...otherprops } = props;

  const [loading, setLoading] = useState(false);
  const [PermissionList, setPermissionsList] = useState([]);
  const [UserList, setUserList] = useState([]);

  const {
    handleOnSelect,
    handleOnSelectAll,
    setSelectedItems,
    SelectedItems,
  } = useSelectItem("TEMPLATE_ID");

  const method = useForm();
  const { getValues, setValue, setError, clearErrors, errors } = method;

  const initScreen = useCallback(
    async (userID) => {
      let param = { USER_ID: userID };
      let res = await api.InitScreen(param);

      let resUsers = await GetListUserMaintenance();
      let options = resUsers
        .filter((u) => u.ACTIVE)
        .map((item) => ({ value: item.USER_ID }));
      setUserList(options);

      const { List_MasterTemplate, Info } = res;
      const { PERMISSION } = Info;

      setPermissionsList(List_MasterTemplate);

      // Bind data
      let result = common.setDataToFormHookV2(Info);
      setTimeout(() => {
        result?.forEach(({ name, value }) => {
          setValue(name, value);
        });
      });

      const filteredTemplates = List_MasterTemplate.filter((template) =>
        PERMISSION.includes(template.TEMPLATE_ID)
      );

      setSelectedItems(filteredTemplates);
    },
    [setValue, setPermissionsList]
  );

  useEffect(() => {
    if (!open) return;
    initScreen(data?.USER_ID);
  }, [initScreen, data, open]);

  const onSaveAuthorize = async () => {
    clearErrors("USER_ID");

    const USER_ID = getValues().USER_ID;

    if (common.isEmptyStr(USER_ID.trim())) {
      setError("USER_ID", {
        type: "manual",
        message: "User ID field is required",
      });
      return;
    }

    if (SelectedItems.length === 0) {
      alertDialog.ErrorDialog("Please select permission.");
      return;
    }

    let param = {
      EDIT_MODE: editmode === 1,
      USER_ID: USER_ID,
      PERMISSION: SelectedItems,
    };

    if (!loading) {
      setLoading(true);
    }

    let resSave = await api.SaveTemplateAuthorize(param);
    setLoading(false);

    if (resSave.ResultCode === 10) {
      // Success
      fetchmain();
      onClose();
      alertDialog.inform_success();
      return;
    }

    if (resSave.ResultCode === 20) {
      alertDialog.ErrorDialog(resSave?.Message);
      return;
    }
  };

  const onHandleChange = (e, searchProps) => {
    searchProps.onSearch(e.target.value);
  };

  const handleChangeAutocomplete = (name, newValue) => {
    setValue(name, newValue);
  };

  const searchcomponent = (searchProps) => {
    return (
      <>
        <Paper component="form" className={classes.rootSearch}>
          <InputBase
            className={classes.input}
            placeholder="Search"
            inputProps={{ "aria-label": "search" }}
            name="TEXT_SEARCH"
            onChange={(e) => onHandleChange(e, searchProps)}
          />
        </Paper>
      </>
    );
  };

  return (
    <Modal
      {...otherprops}
      onSave={onSaveAuthorize}
      maxWidth="md"
      title={`${editmode ? "Edit" : "Add"} Config Template Authorize.`}
    >
      <FormProvider {...method}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={2}>
            <FormControl variant="outlined" className={classes.labelTitle}>
              <InputLabel className={classes.textLabel}>User Id : </InputLabel>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={10}>
            <FormAutocomplete
              id="outlined-full-width"
              name="USER_ID"
              className={classes.inputHeader}
              disabled={editmode === 1}
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              errorobj={errors}
              options={UserList}
              handleChange={handleChangeAutocomplete}
            />
          </Grid>
          <Grid item sm={12}>
            <BoxTemplate1 height="50vh" title="Permission" fontSize="20px">
              <ReactTable
                keyField="TEMPLATE_ID"
                data={PermissionList}
                selectedRow={SelectedItems}
                showSearch={false}
                clickToSelect
                clickRowToSelect={true}
                selectStyle={{ backgroundColor: "rgb(122, 255, 166)" }}
                handleOnSelect={handleOnSelect}
                handleOnSelectAll={handleOnSelectAll}
                headRightcomponent={searchcomponent}
                columns={getPermissionColumns()}
              />
            </BoxTemplate1>
          </Grid>
          <Grid item xs={12}>
            {loading && <LinearProgress />}
            {loading && <LinearProgress color="secondary" />}
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  );
}
export default AddEditTemplateAuthorizeModal;
